exports = module.exports = require("../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ad-group-form[data-v-6c0445d1] {\n  margin-bottom: 20px;\n}\n.form-tip[data-v-6c0445d1] {\n  font-size: 12px;\n  color: red;\n  line-height: 1.5;\n  margin-left: 10px;\n}", ""]);

// exports
